/* L&S: Produkt- und Kategorie-Reihen springen automatisch ein Element weiter, am Ende wieder an den Anfang.
   Aktiv nur, wenn die Reihe tatsächlich scrollbar und im Bild ist. Pausiert bei Maus, Fokus, Wischen und Tippen,
   bleibt nach einer Nutzer-Interaktion kurz stehen. Bei „Bewegung reduzieren“ aus. */
(function () {
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(component) {
    if (component.dataset.lsAutoplayReady) return;
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;
    component.dataset.lsAutoplayReady = '1';

    const delay = Math.max(2, parseFloat(component.dataset.lsAutoplay) || 4) * 1000;
    let timer = null;
    let visible = false;
    let hover = false;
    let holdUntil = 0;
    let lastLeft = null;

    const step = () => {
      const first = slider.querySelector('.slider__slide, .grid__item');
      const second = first && first.nextElementSibling;
      if (!first) return slider.clientWidth;
      return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
    };

    const tick = () => {
      if (calm.matches || hover || !visible || Date.now() < holdUntil || document.hidden) return;
      const max = slider.scrollWidth - slider.clientWidth;
      if (max <= 4) return; // alles sichtbar, nichts zu tun
      // Ende erkannt, wenn rechnerisch erreicht oder wenn der letzte Sprung nichts mehr bewegt hat (Einrasten hält vor dem Ende)
      const stuck = lastLeft !== null && Math.abs(slider.scrollLeft - lastLeft) < 2;
      const rest = max - slider.scrollLeft;
      const atEnd = rest <= 4 || rest < step() / 2 || stuck;
      const next = atEnd ? 0 : Math.min(slider.scrollLeft + step(), max);
      lastLeft = atEnd ? null : slider.scrollLeft;
      slider.scrollTo({ left: next, behavior: 'smooth' });
    };

    const start = () => {
      if (!timer) timer = window.setInterval(tick, delay);
    };
    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };
    const hold = () => {
      holdUntil = Date.now() + delay * 2;
      lastLeft = null;
    };

    component.addEventListener('mouseenter', () => (hover = true));
    component.addEventListener('mouseleave', () => (hover = false));
    component.addEventListener('focusin', () => (hover = true));
    component.addEventListener('focusout', () => (hover = false));
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => slider.addEventListener(ev, hold, { passive: true }));
    component.addEventListener('click', (e) => e.target.closest('.slider-button') && hold());

    new IntersectionObserver(
      (entries) => {
        visible = entries[0].isIntersecting;
        if (visible) start();
        else stop();
      },
      { threshold: 0.4 }
    ).observe(slider);
  }

  function init() {
    document.querySelectorAll('slider-component[data-ls-autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
